import React from "react";

import * as Styled from "./styles";

interface Props {
  checked: boolean;
  text: string;
  onClick: () => void;
}

const CheckBox: React.FC<Props> = ({ checked, text, onClick }) => (
  <Styled.CheckContainer>
    <Styled.CustomCheckbox checked={checked} onClick={onClick} />
    <Styled.Description>{text}</Styled.Description>
  </Styled.CheckContainer>
);

export default CheckBox;
